export default __webpack_public_path__ + "static/media/Kanipakam-2.3e5664be.png";